var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-rate"},[_c('label',{staticClass:"buy-rate__title"},[_vm._v("Include Buy Rate")]),_c('b-form-checkbox',{staticClass:"document-item__checkbox",model:{value:(_vm.includeBuyRate),callback:function ($$v) {_vm.includeBuyRate=$$v},expression:"includeBuyRate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }